<template></template>

<script>
import { handleLogout } from "../../utils/auth";

export default {
  created() {
    handleLogout();
    window.location.href = "/login";
  }
};
</script>